import React, { useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WidgetWrapper } from '@/src/components/projects/ProjectDashboard/WidgetWrapper.jsx';
import { WidgetInner } from '@/src/components/projects/ProjectDashboard/WidgetInner.jsx';
import PeopleEngagementTable from './PeopleEngagementTable/index.jsx';
import { FormControl } from 'react-bootstrap';
import {
  loadingContent,
  peopleEngagementWidgetContent,
} from '@/src/components/EmptyStates.jsx';
import Empty from '@/src/components/Empty.jsx';
import { buildPath } from '@/src/components/Link.jsx';
import { PROJECTS_INITIATIVES } from '@/src/constants/routes.js';

export const PeopleEngagementWidget = ({
  data,
  query,
  searchState,
  onSearch,
}) => {
  const navigate = useNavigate();
  const { slug, projectId } = useParams();
  const hasEverSearched = useRef(false);

  const handleNavigateToInitiatives = () => {
    const path = buildPath(PROJECTS_INITIATIVES, { slug, projectId });
    navigate(path);
  };
  const hasData = data?.groups && data.groups.length > 0;
  const isLoading = searchState?.pending;
  const hasSearchQuery = query && query.length > 0;

  if (hasSearchQuery && !hasEverSearched.current) {
    hasEverSearched.current = true;
  }

  const renderContent = () => {
    if (isLoading && !hasSearchQuery) {
      return (
        <WidgetInner height={530} className="px-0 py-0 flex flex-col">
          <Empty simplified content={loadingContent} />
        </WidgetInner>
      );
    }

    if (!hasData && !hasSearchQuery && !isLoading && !hasEverSearched.current) {
      return (
        <WidgetInner height={530} className="px-0 py-0 flex flex-col">
          <Empty
            simplified
            content={peopleEngagementWidgetContent}
            action={handleNavigateToInitiatives}
          />
        </WidgetInner>
      );
    }

    return (
      <WidgetInner height={530} className="px-0 py-0">
        <PeopleEngagementTable data={data.groups} />
      </WidgetInner>
    );
  };

  return (
    <WidgetWrapper className="people-engagement-widget">
      <div className="flex flex-justify  m-b-12">
        <div className="flex align-center">
          <h2>People Engagement & Impact Overview</h2>
          <strong className="header-item bordered component-bg-white text-primary">
            <span className="text-muted">Total: </span>
            <span>{data?.total || 0}</span>
          </strong>
        </div>
        <div style={{ width: '100%', maxWidth: '372px' }}>
          <FormControl
            placeholder="Search"
            type="text"
            onChange={onSearch}
            disabled={
              !hasData &&
              !hasSearchQuery &&
              !isLoading &&
              !hasEverSearched.current
            }
          />
        </div>
      </div>
      {renderContent()}
    </WidgetWrapper>
  );
};
